const Container = require("./Container");
const Content = require("./Content");
const Description = require("./Description");
const Pane = require("./Pane");
const Title = require("./Title");

module.exports = {
  Container,
  Content,
  Description,
  Pane,
  Title,
};
